import { getEntryDraftKey } from './getEntryDraftKey';
import { useEntryDraftState } from './useEntryDraftState';

export const useEntryDraftById = ({ activeProfileId, entryId, blog }) => {
  const [draft] = useEntryDraftState();

  const entryDrafts = draft?.[activeProfileId] ?? {};

  return entryDrafts[getEntryDraftKey(entryId, blog)] ?? {};
};
